import * as React from "react";
import { createContext, useContext } from "react";
import useForwarderInputMetrics, { compositeIdFor } from "../hooks/useForwarderInputMetrics";
const EMPTY_CONTEXT = {
  metricsByPair: {},
  isInitialLoading: false,
  isError: false
};
const ForwarderInputMetricsContext = createContext(EMPTY_CONTEXT);
export const ForwarderInputMetricsProvider = ({ pairs, fields, children = void 0 }) => {
  const { metricsByPair, isInitialLoading, isError } = useForwarderInputMetrics(pairs, fields);
  const value = {
    metricsByPair,
    isInitialLoading,
    isError
  };
  return /* @__PURE__ */ React.createElement(ForwarderInputMetricsContext.Provider, { value }, children);
};
export const useForwarderInputMetricsContext = () => useContext(ForwarderInputMetricsContext);
export const useForwarderInputMetricsFor = (inputId, forwarderNodeId) => {
  const { metricsByPair, isInitialLoading, isError } = useContext(ForwarderInputMetricsContext);
  return {
    metrics: metricsByPair[compositeIdFor({ input_id: inputId, forwarder_node_id: forwarderNodeId })],
    isInitialLoading,
    isError
  };
};
export default ForwarderInputMetricsContext;
